import React from 'react';
import { Box, Text, Button, Heading } from '@wix/design-system';
import { ExternalLinkSmall } from '@wix/wix-ui-icons-common/lazy';
import style from './wix-capital-dealer-banner.module.scss';

export interface WixCapitalDealerBannerAssets {
  titleText?: string;
  subtitleText?: string;
  ctaText?: string;
  logoUrl?: string;
  appId?: string;
}

export interface WixCapitalDealerBannerProps {
  assets?: WixCapitalDealerBannerAssets;
  parsedCtaUrl?: string;
  onPrimaryCtaClick: () => void;
}

export function WixCapitalDealerBanner({
  assets,
  parsedCtaUrl,
  onPrimaryCtaClick,
}: WixCapitalDealerBannerProps) {
  if (!assets) {
    return null;
  }

  return (
    <Box
      marginTop="SP3"
      marginBottom="SP3"
      width="100%"
      borderRadius="8px"
      className={style.bannerContainer}
    >
      <Box
        width="100%"
        verticalAlign="middle"
        gap="SP3"
        padding="SP4"
        justifyItems="space-between"
      >
        <Box direction="vertical" gap="SP1">
          <Heading size="medium">{assets.titleText}</Heading>
          <Box maxWidth="546px">
            <Text size="small">{assets.subtitleText}</Text>
          </Box>
          <Box marginTop="SP3">
            {assets.appId ? (
              <Button size="small" skin="dark" onClick={onPrimaryCtaClick}>
                {assets.ctaText}
              </Button>
            ) : (
              <Button
                size="small"
                as="a"
                href={parsedCtaUrl}
                skin="dark"
                target="_blank"
                onClick={onPrimaryCtaClick}
                suffixIcon={<ExternalLinkSmall />}
              >
                {assets.ctaText}
              </Button>
            )}
          </Box>
        </Box>
        <Box marginLeft="auto">
          {assets.logoUrl && (
            <img
              src={assets.logoUrl}
              alt=""
              style={{
                display: 'block',
                maxHeight: '100px',
                maxWidth: '280px',
              }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
}
